module.exports = __webpack_public_path__ + "static/media/farre50.b2ab4273.svg";